<template>
    <sub-controller></sub-controller>
</template>

<script>
    import ModelElement from "../../modeling/ModelElement";
    import VueSuperMethod from 'vue-super-call'
    import SubController from "../../../opengraph/shape/SubController";

    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    // Vue.prototype.$super = VueSuperMethod

    export default {
        components: {SubController},
        mixins: [ModelElement],
        name: 'event-storming-model-element',
        props: {},
        data() {
            return {
                panelStyle: 'width:500px;',
                namePanel: '',
                descriptionPanel: '',
                isPassedClosePanel: false,
                staySetTimeout: null,

                rotateStatus: false,
                isMovedElement: false,
                attachedBoundedContext: false,
                attachedBoundedContextId: null,
                attachedAggregate: false,
                attachedAggregateId: null,
                // oldName: "",
                info_red_image: 'static/image/symbol/close-icon-red.png',
                info_white_image: 'static/image/symbol/info-icon-white.png',
                error_white_image: 'static/image/symbol/error-icon-white.png',
                warning_white_image: 'static/image/symbol/warning-icon-white.png',
                ////////////////////// Validation ERROR CODE /////////////////////////////
                ESE_NOT_NAME: 0,
                ESE_NOT_BC: 1,
                ESE_NOT_AGG: 2,
                ESE_NOT_PK: 3,
                ESE_DUPLICATE_FIELD: 4,
                ESE_API_PATH_ERROR: 5,
                validationCodeLists: {
                    0: {
                        'level': 'error',
                        'msg': ' Must have a name.'
                    },
                    1: {
                        'level': 'info',
                        'msg': 'Element must be in a Bounded Context.'
                    },
                    2: {
                        'level': 'warning',
                        'msg': 'Must be attached to an Aggregate.'
                    },
                    3: {
                        'level': 'error',
                        'msg': 'Key is undefined.'
                    },
                    4: {
                        'level': 'error',
                        'msg': 'Attribute name is duplicated.'
                    },
                    5: {
                        'level': 'error',
                        'msg': 'Blank, space, or special characters are not allowed for the API path.'
                    }
                },
                /////////////////////////////////

            }
        },
        created: function () {
            var me = this
            //필수
            try {
                me.setUserInfo()
                var className = me.value ? me.value._type : null


                // Init Common panel-value Setting
                me.namePanel = me.value.name

                // Init Sticker & Relation setting
                if (className && className.endsWith('Relation')) {
                    //relations

                } else {
                    //elements
                    if (me.value.description) {
                        me.descriptionPanel = me.value.description
                    }
                }


                if (me.$route.path.includes('replay')) {
                    me.canvasbase = me.getComponent('event-storming-model-replay');
                    me.panelStyle = 'width:500px; margin-right:17.5%;'
                } else {
                    me.canvasbase = me.getComponent('event-storming-model-canvas');
                }


                if (className) {
                    var componentName = me.getComponentByClassName(className).name
                    var component = me.canvasbase.elementTypes.find(x => x.component == componentName)
                    if (component) {
                        me.image = component.src
                    }
                }

                me.validate(null, false)
            } catch (e) {
                alert('Error: modelCanvas 선언 필수.', e)
            }
        },
        computed: {
            elementCoordinate(){
                if(this.isHexagonalModeling){
                    this.value.hexagonalView.angle = 0
                    return this.value.hexagonalView
                }
                return this.value.elementView
            },
            isHexagonalModeling() {
                if (this.canvasbase) {
                    return this.canvasbase.isHexagonalModeling
                }
                return false
            },
            showValidation() {
                if (this.elementValidationResults.length == 0) {
                    return false
                }
                return true
            },
            showValidationImg() {
                if (this.elementValidationResults.length == 0) {
                    return null
                }
                var level = this.filteredElementValidationResults[0].level
                if (level) {
                    if (level == 'error') {
                        return this.info_red_image
                        // return this.error_white_image
                    } else if (level == 'warning') {
                        return this.warning_white_image
                    } else if (level == 'info') {
                        return this.info_white_image
                    }
                }
                return null
            },
            statusCompleteStyle() {
                if (this.STATUS_COMPLETE) {
                    return {'r': '0'}
                }
                return {'r': '2', 'fill-opacity': 1, 'fill': '#F24040', 'stroke': '#F24040'}
            },
            getNamePanel() {
                return this.namePanel
            },
            getDescriptionPanel() {
                return this.descriptionPanel
            },
            elementAuthor() {
                return this.value.author
            },
            isReadOnly() {
                if (this.canvasbase) {
                    return this.canvasbase.readOnly
                } else {
                    return false
                }
            },
            isEditElement() {
                // true : edit 0 , false: edit x
                var me = this
                if (me.canvasbase) {

                    if (me.isReadModeling) {
                        return false
                    } else if (!me.isServerModeling) {
                        return true
                    } else {
                        if (me.canvasbase.information && me.canvasbase.information.author) {
                            if (me.newEditUserImg && me.newEditUserImg.length > 0) {

                                if (me.getEditUid == me.newEditUserImg[0].uid) {
                                    //project author
                                    return true
                                } else {

                                    if (me.canvasbase.participantLists.filter(user => user.uid == me.newEditUserImg[0].uid).length == 0) {
                                        me.newEditUserImg.splice(0, 1)
                                        // Not Exit User
                                        return true
                                    }

                                    if (me.newEditUserImg[0].action == 'userSelectedOn'
                                        || me.newEditUserImg[0].action == 'userMovedOn') {
                                        return false
                                    }

                                    return false
                                }
                            }
                        }
                    }
                }
                return true
            },
        },
        watch: {
            "isHexagonalModeling": function (newVal, oldVal) {
                this.refresh()
            },
            "statusCompleteStyle": {
                deep: true,
                handler: _.debounce(function () {
                    this.refresh()
                }, 200)
            },
            "movingElement": {
                deep: true,
                handler: function (newVal, oldVal) {
                    var me = this
                    var diff = jsondiffpatch.diff(newVal, oldVal)
                    if (newVal && diff && me.isServerModeling) {
                        me.validate()
                    }
                }
            },
            "value.elementView": {
                deep: true,
                handler: function (newVal, oldVal) {
                    var me = this
                    if (!me.isServerModeling) {
                        me.validate()
                    }
                }
            },
            "value.name": function (newVal, oldVal) {
                this.namePanel = newVal;
                this.validate(null, false)
            },
            "value.description": function (newVal) {
                this.descriptionPanel = newVal
                this.refresh()
            },
            "getNamePanel": {
                deep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    if (newVal != oldVal)
                        this.refresh()
                }, 200)
            },
            "getDescriptionPanel": {
                deep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    if (newVal != oldVal)
                        this.refresh()
                }, 200)
            },
            'staySelected': function (newVal, oldVal) {
                if (newVal) {
                    this.selectedStayActivity()
                } else {
                    this.deSelectedStayActivity()
                }

            },
            'selected': _.debounce(function (newVal, oldVal) {
                if (newVal) {
                    if (this.propertyPanel) {
                        this.staySelected = false
                    } else {
                        this.staySelected = true
                    }
                } else {
                    this.staySelected = false
                }

            }, 2000),
            "filteredElementValidationResults": _.debounce(function () {
                this.refresh()
            }, 200),
        },
        mounted() {
            var me = this
            me.$EventBus.$on('isMovedElement', function (id) {
                if (me.value.elementView) {
                    //only Element
                    if (me.value.elementView.id == id) {
                        me.isMovedElement = true
                        me.movedNewActivity()
                    } else {
                        if (me.isMovedElement == true) {
                            me.isMovedElement = false
                            me.movedOldActivity()
                        }
                    }
                }
            })
            me.$ModelingBus.$on("clearOld", function () {
                me.value.oldName = undefined
            })
            me.$nextTick(function () {
                $(document).keydown((evt) => {
                    // element copy & paste
                    if (evt.keyCode == 67 && (evt.metaKey || evt.ctrlKey)) {
                        if (!evt.target.localName.includes('input')) {
                            // me.copy();
                        }
                    } else if (evt.keyCode == 86 && (evt.ctrlKey || evt.metaKey)) {
                        if (!evt.target.localName.includes('input')) {
                            // me.paste();
                        }

                    }
                });
            })

            me.$EventBus.$on('copyPaste', function (id) {
                if (id == me.value.elementView.id) {
                    me.copy();
                    me.paste();
                } else {
                    me.tmpValue = null;
                }
            })

        },
        methods: {
            delayedMove(dx, dy, dw, dh, du, dlw, dl, dr) {
                var me = this
                try{
                    var offsetX, offsetY, offsetW, offsetH

                    var originX = me.isHexagonalModeling ? me.value.hexagonalView.x : me.value.elementView.x
                    var originY = me.isHexagonalModeling ? me.value.hexagonalView.y : me.value.elementView.y
                    var originW = me.isHexagonalModeling ? me.value.hexagonalView.width : me.value.elementView.width
                    var originH = me.isHexagonalModeling ? me.value.hexagonalView.height : me.value.elementView.height

                    if (dx == null && dy == null) {
                        // resize

                        if (Math.abs(dl) <= Math.abs(dr)) {
                            // 오른쪽으로 움직임
                            if (dr >= 0) {
                                offsetX = originX + (Math.abs(dl + dr) / 2.0)
                            } else {
                                offsetX = originX - (Math.abs(dl + dr) / 2.0)
                            }


                        } else if (Math.abs(dl) > Math.abs(dr)) {
                            // 왼쪽 으로 움직임
                            if (dl >= 0) {
                                offsetX = originX - (Math.abs(dl + dr) / 2.0)
                            } else {
                                offsetX = originX + (Math.abs(dl + dr) / 2.0)
                            }

                        }

                        if (Math.abs(dlw) <= Math.abs(du)) {
                            //위로 움직임
                            if (du >= 0) {
                                offsetY = originY - (Math.abs(du + dlw) / 2.0)
                            } else {
                                offsetY = originY + (Math.abs(du + dlw) / 2.0)
                            }

                        } else if (Math.abs(dlw) > Math.abs(du)) {
                            //아래로 움직임
                            if (dlw >= 0) {
                                offsetY = originY + (Math.abs(du + dlw) / 2.0)
                            } else {
                                offsetY = originY - (Math.abs(du + dlw) / 2.0)
                            }

                        }

                        offsetW = dw
                        offsetH = dh

                    } else if (dw == null && dh == null) {
                        //move
                        offsetX = originX + dx
                        offsetY = originY + dy
                        offsetW = originW
                        offsetH = originH
                    } else {
                        console.log('error Move & Resize')
                    }

                    var afterViewObj = {x: offsetX, y: offsetY, width: offsetW, height: offsetH}
                    var beforeViewObj = {x: originX, y: originY, width: originW, height: originH}

                    me.delayedMoveAction(beforeViewObj, afterViewObj)

                }catch (e) {
                    alert(`[Error] ModelElement-delayedMove: ${e}`)
                }
            },
            delayedRelationMove(vertices) {
                var me = this
                try{
                    var getVertices = me.isHexagonalModeling ? me.value.hexagonalView.value : me.value.relationView.value

                    var originVertices = JSON.parse(JSON.stringify(getVertices))
                    var newVertices = []
                    var offsetVertices

                    vertices.forEach(function (ver, index) {
                        newVertices.push([ver.x, ver.y])
                    })
                    offsetVertices = JSON.stringify(newVertices)

                    me.delayedRelationMoveAction(originVertices, offsetVertices)
                }catch (e) {
                    alert(`[Error] ModelElement - delayedRelationMove: ${e}`)
                }
            },
            changedPanelValue(value) {
                this.validate(value, false)
            },
            validationFromCode(code) {

                if (code == null) {
                    return null
                }

                if (code == undefined) {
                    return null
                }

                var validationCode = this.validationCodeLists[code]
                if (validationCode) {
                    validationCode.code = code
                    return validationCode
                }

                return null
            },
            copy: function () {
                var me = this
                // if(me.selected) {
                me.tmpValue = JSON.parse(JSON.stringify(me.value))
                // } else {
                //     me.tmpValue = null
                // }
            },
            paste: function () {
                var me = this
                if (!me.isReadModeling) {
                    if (me.tmpValue) {
                        var tmp = me.tmpValue
                        tmp.elementView.id = me.canvasbase.uuid();
                        tmp.elementView.x = tmp.elementView.x + Math.floor(Math.random() * 101)
                        tmp.elementView.y = tmp.elementView.y + Math.floor(Math.random() * 101)

                        me.canvasbase.addElementPush(tmp)
                    }
                }
            },
            onMoveShape: function () {
                this.$EventBus.$emit('isMovedElement', this.value.elementView.id)
            },
            selectedActivity: function () {
                var me = this
                if (this.value) {
                    this.selected = true

                    // selected Template
                    var elementIds = me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                    elementIds = elementIds ? JSON.parse(JSON.stringify(elementIds)) : JSON.parse(JSON.stringify(me.elementId))
                    var elementType = me.value._type ? me.value._type : null
                    me.$EventBus.$emit('elementTemplate', {selected: true, id: elementIds, type: elementType})
                }

            },
            deSelectedActivity: function () {
                var me = this
                if (this.value) {
                    this.propertyPanel = false
                    this.selected = false
                    this.staySelected = false

                    // deselected Template
                    var elementIds = me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                    elementIds = elementIds ? JSON.parse(JSON.stringify(elementIds)) : JSON.parse(JSON.stringify(me.elementId))
                    me.$EventBus.$emit('elementTemplate', {selected: false, id: elementIds})
                }

            },
            movedNewActivity() {
                var me = this
                try {
                    if (me.isLogin && me.isCustomMoveExist && !me.isClazzModeling && !me.isHexagonalModeling ) {
                        var obj = {
                            action: 'userMovedOn',
                            editUid: me.userInfo.uid,
                            name: me.userInfo.name,
                            picture: me.userInfo.profile,
                            timeStamp: Date.now(),
                            editElement: me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                        }
                        me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, obj)
                    }
                } catch (e) {
                    alert(`[Error] ESModelElement-movedNewActivity: ${e}`)
                }
            },
            movedOldActivity() {
                var me = this

                try {
                    if (me.isLogin && me.isCustomMoveExist && !me.isClazzModeling && !me.isHexagonalModeling ) {
                        var obj = {
                            action: 'userMovedOff',
                            editUid: me.userInfo.uid,
                            name: me.userInfo.name,
                            picture: me.userInfo.profile,
                            timeStamp: Date.now(),
                            editElement: me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                        }
                        me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, obj)
                    }
                } catch (e) {
                    alert(`[Error] ESModelElement-movedOldActivity: ${e}`)
                }
            },
            selectedStayActivity() {
                var me = this

                try {
                    if (me.isLogin && me.isCustomMoveExist && !me.isClazzModeling && !me.isHexagonalModeling ) {

                        var elementIds = me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                        elementIds = elementIds ? JSON.parse(JSON.stringify(elementIds)) : JSON.parse(JSON.stringify(me.elementId))
                        var elementType = me.value._type ? me.value._type : null

                        var obj = {
                            action: 'userSelectedOn',
                            editUid: me.userInfo.uid,
                            name: me.userInfo.name,
                            picture: me.userInfo.profile,
                            timeStamp: Date.now(),
                            // editElement: me.value.elementView.id
                            editElement: me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                        }
                        me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, obj)
                    }
                } catch (e) {
                    alert(`[Error] ESModelElement-selectedStayActivity: ${e}`)
                }


                // me.$EventBus.$emit('elementTemplate', { selected: true, id : elementIds, type: elementType })
            },
            deSelectedStayActivity() {
                var me = this
                try {
                    if (me.isLogin && me.isCustomMoveExist && !me.isClazzModeling && !me.isHexagonalModeling ) {

                        var elementIds = me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                        elementIds = elementIds ? JSON.parse(JSON.stringify(elementIds)) : JSON.parse(JSON.stringify(me.elementId))

                        var obj = {
                            action: 'userSelectedOff',
                            editUid: me.userInfo.uid,
                            name: me.userInfo.name,
                            picture: me.userInfo.profile,
                            timeStamp: Date.now(),
                            // editElement: me.value.elementView.id
                            editElement: me.value.elementView ? me.value.elementView.id : me.value.relationView.id
                        }
                        me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, obj)
                    }
                } catch (e) {
                    alert(`[Error] ESModelElement-deSelectedStayActivity: ${e}`)
                }

                // me.$EventBus.$emit('elementTemplate',{ selected: false, id : elementIds })
            },
            refresh() {
                this.refreshImg()
            },
            onRotateShape: function (element, angle) {
                // console.log('ES: onRotateShape: ', element,angle)
                // this.value.elementView.angle = angle
            },
            validate() {
                var me = this
                var changedAttachedElement = false

                if (me.canvasbase.attachedLists && me.canvasbase.attachedLists.boundedContextLists) {
                    me.attachedBoundedContext = Object.values(me.canvasbase.attachedLists.boundedContextLists).some(bc => {
                        if (me.isAttached(bc)) {
                            var newAttachedBoundedContextId = null

                            me.value.boundedContext = {name: bc.name, id: bc.elementView.id}
                            newAttachedBoundedContextId = bc.elementView.id

                            // 움직일때 BC 변화 파악.
                            if (me.value && newAttachedBoundedContextId != me.attachedBoundedContextId) {
                                me.attachedBoundedContextId = newAttachedBoundedContextId
                                changedAttachedElement = true
                            }

                            // validationResults
                            var validationResultIndex = me.elementValidationResults.findIndex(x => (x.code == me.ESE_NOT_BC))
                            var isExistValidationResult = validationResultIndex == -1 ? false : true
                            if (isExistValidationResult) {
                                me.elementValidationResults.splice(validationResultIndex, 1)
                            }

                        } else {
                            me.value.boundedContext = undefined
                            me.attachedBoundedContextId = null

                            // validationResults
                            var validationResultIndex = me.elementValidationResults.findIndex(x => (x.code == me.ESE_NOT_BC))
                            var isExistValidationResult = validationResultIndex == -1 ? false : true
                            if (!isExistValidationResult) {
                                me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_BC))
                            }
                        }

                        return me.isAttached(bc);
                    })
                }

            },
            isAggAttached: function (otherElement) {


                var me = this;

                var outer = {
                    x: (otherElement.elementView.x - otherElement.elementView.width / 2) - 10,
                    y: (otherElement.elementView.y - otherElement.elementView.height / 2) - 10,
                    width: otherElement.elementView.width + 20,
                    height: otherElement.elementView.height + 20
                }
                var inner = {
                    x: me.value.elementView.x - me.value.elementView.width / 2,
                    y: me.value.elementView.y - me.value.elementView.height / 2,
                    width: me.value.elementView.width,
                    height: me.value.elementView.height
                }


                return me._isAttached(outer, inner)
            },
            delayedMoveAction(beforeViewObj, afterViewObj) {
                var me = this

                if (me.isCustomMoveExist) {
                    me.movingElement = false

                    // FIRST UI Then Queue push
                    me.onMoveElement(afterViewObj, false)

                    // move Queue
                    me.delayedMoveQueue(beforeViewObj, afterViewObj)
                }
            },
            delayedRelationMoveAction(originVertices, offsetVertices) {
                var me = this

                if (me.isCustomMoveExist) {
                    me.movingElement = false

                    // FIRST UI Then Queue push
                    me.onMoveRelation(offsetVertices, false)

                    // relation Queue
                    me.delayedRelationMoveQueue(originVertices, offsetVertices)
                }
            },
            onMoveElement(newObj,STATUS_COMPLETE){
                var me = this

                try{

                    var setX = me.isHexagonalModeling ? me.value.hexagonalView.x : me.value.elementView.x
                    var setY = me.isHexagonalModeling ? me.value.hexagonalView.y : me.value.elementView.y
                    var setWidth = me.isHexagonalModeling ? me.value.hexagonalView.width : me.value.elementView.width
                    var setHeight = me.isHexagonalModeling ? me.value.hexagonalView.height : me.value.elementView.height

                    setX = newObj.x
                    setY = newObj.y
                    setWidth = newObj.width
                    setHeight = newObj.height

                    me.$nextTick(function () {
                        me.movingElement = true
                        me.STATUS_COMPLETE = STATUS_COMPLETE
                    })
                }catch (e) {
                    alert(`[Error] ModelElement-onMoveElement: ${e}`)
                }
            },
            onMoveRelation(newObj,STATUS_COMPLETE){
                var me = this

                try{
                    var setVertices = me.isHexagonalModeling ? me.value.hexagonalView.value : me.value.relationView.value

                    setVertices = newObj

                    me.$nextTick(function () {
                        me.movingElement = true
                        me.STATUS_COMPLETE = STATUS_COMPLETE
                    })
                }catch (e) {
                    alert(`[Error] ModelElement-onMoveRelation: ${e}`)
                }
            },
            delayedMoveQueue(beforeViewObj , afterViewObj){
                var me = this
                try{
                    var types = me.value._type.split('.')
                    var pushObj =
                        {
                            action: 'elementMove',
                            elementType: types[types.length - 1],
                            elementName: me.value.name,
                            editUid: me.getEditUid,
                            elementId: me.value.elementView.id,
                            before: JSON.stringify(beforeViewObj),
                            after: JSON.stringify(afterViewObj),
                            timeStamp: Date.now(),
                        }

                    if(me.isHexagonalModeling){
                        pushObj.isHexagonal = true
                    }
                    me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, pushObj)
                }catch (e) {
                    alert(`[Error] ModelElement-DelayedMoveQueue PUSH: ${e}`)
                }
            },
            delayedRelationMoveQueue(originVertices , offsetVertices){
                var me = this
                try {
                    var pushObj =
                        {
                            action: 'relationMove',
                            editUid: me.getEditUid,
                            relationId: me.value.relationView.id,
                            before: originVertices,
                            after: offsetVertices,
                            timeStamp: Date.now(),
                        }
                    if(me.isHexagonalModeling){
                        pushObj.isHexagonal = true
                    }
                    me.pushObject(`db://definitions/${me.modelingProjectId}/queue`, pushObj)
                }catch (e) {
                    alert(`[Error] ModelElement-DelayedRelationMoveQueue: ${e}`)
                }
            },
            getComponentByClassName: function (className) {
                var componentByClassName;

                // $.each(window.Vue.eventStormingModelingComponents, function (i, component) {
                $.each(window.Vue.eventStormingModelingComponents, function (i, component) {
                    if (component.default.computed && component.default.computed.className && component.default.computed.className() == className) {
                        componentByClassName = component.default;
                    }
                });
                return componentByClassName;
            },
            onAddedToGroup: function (groupElement, element, eventOffset) {
                var me = this;

                if (groupElement.tagName) {
                    // Canvas로 나가는 경우

                } else {
                    // lee
                    // if (groupElement.$parent.value._type.includes('BoundedContext')) {
                    //     groupElement.$parent.value.innerElement.push(element.$parent.value.elementView.id)
                    // }
                }
            },
        }
    }
</script>
